import React, { Component } from 'react';
import { connect } from "react-redux";
import {setSelectedPreset, setPresetDragging} from 'actions/index.js';
import ethereum from 'decentralized/ethereum.js';

const MAX_LENGTH = 40;

class ItemComponent extends Component {
    constructor(props) {
        super(props);

    }

    onClick() {
        let now = new Date().getTime();
        if (this.lastDate !== undefined && now - this.lastDate < 500) {
            // i.e. double click chooses the item
            this.props.onChooseItem(this.props.item);
        }
        this.lastDate = now;
        this.props.setSelectedPreset(this.props.item);
    }

    onDragOver(e) {
        e.preventDefault();
    }

    onDragStart(e) {
        this.props.setPresetDragging(this.props.item);
    }

    get name() {
        if (this.props.item.name.length > MAX_LENGTH) {
            return this.props.item.name.slice(0, MAX_LENGTH) + '...';
        }
        return this.props.item.name;
    }

    render() {
        let style = {
            paddingLeft: this.props.depth*17,
        };

        let className = this.props.selectedPreset === this.props.item ?
            "folder-item selected" : "folder-item";
        return (
            <div
              draggable={true}
              onDragStart={(e) => this.onDragStart()}
              onDragOver={(e) => this.onDragOver(e)}
              onClick={() => this.onClick()}
              className={className} style={style}>
              <div
                onClick={() => this.props.onTestItem(this.props.item)}
                className="item-icon"></div>
              {this.name}
            </div>    
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedPreset: m => dispatch(setSelectedPreset(m)),
        setPresetDragging: m => dispatch(setPresetDragging(m)),
    };
};

const mapStateToProps = state => {
    return {
        selectedPreset: state.presets.selectedPreset,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(ItemComponent);

